export const playerDocs = {
  "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5": {
    "alias": "Proper Lemur",
    "currency": 550,
    "currencyTotal": 950,
    "displayName": "Julian S",
    "enroll_method": "upload",
    "fName": "Julian",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #efbbb5, #5696a5)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Sterling",
    "path": "o0bdk4vme7-ev7p6q3",
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "points": 450,
    "status": "active",
    "team": false,
    "ts": 1774615665827
  },
  "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq": {
    "alias": "Inventive Mantis",
    "currency": 200,
    "currencyTotal": 200,
    "displayName": "Ivy S",
    "enroll_method": "upload",
    "fName": "Ivy",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #f99e72, #3b2bd3)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Sinclair",
    "path": "q5cqhyxw6mpw9rd3ni",
    "playerId": "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1773161482683
  },
  "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf": {
    "alias": "Faithful Deer",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Marcus T",
    "enroll_method": "upload",
    "fName": "Marcus",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #065868, #3c6b24)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Thorne",
    "path": "s_04hnqzcm2yjumnb0",
    "playerId": "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9": {
    "alias": "Questioning Hawk",
    "currency": 300,
    "currencyTotal": 300,
    "displayName": "Victor H",
    "enroll_method": "upload",
    "fName": "Victor",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #b8b43c, #9fb4c1)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Hugo",
    "path": "x3tvmbhymif00362ni",
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "points": 20,
    "status": "active",
    "team": false,
    "ts": 1774643897922
  },
  "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03": {
    "alias": "Cautious Curlew",
    "currency": 300,
    "currencyTotal": 300,
    "displayName": "Silas V",
    "enroll_method": "upload",
    "fName": "Silas",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #70a495, #cd4f39)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Vane",
    "path": "bmvh6aoda7y9uojcw_",
    "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1774615665899
  },
  "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F": {
    "alias": "Busy Jaguar",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Isabella R",
    "enroll_method": "upload",
    "fName": "Isabella",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #7d295a, #d61cff)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Romero",
    "path": "0d4po53js6vt59f8zj",
    "playerId": "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM": {
    "alias": "Popular Dolphin",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Penelope W",
    "enroll_method": "upload",
    "fName": "Penelope",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #22e58e, #ff6fa6)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Weaver",
    "path": "p_ui6ws5754qspj2fk",
    "playerId": "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur": {
    "alias": "Patient Crane",
    "currency": 200,
    "currencyTotal": 200,
    "displayName": "Jasper F",
    "enroll_method": "upload",
    "fName": "Jasper",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #12cf02, #ce2e13)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Finch",
    "path": "cudo2o__jhdh0_hm42",
    "playerId": "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772981267710
  },
  "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team": {
    "currency": 0,
    "currencyTotal": 0,
    "desc": "Named after the Senatus, the governing body of Rome. This title fits a team that excels at the rhetorical and analytical side of your literature curriculum the ones who love a good Socratic seminar.",
    "displayName": "The Gilded Senate",
    "enroll_method": "",
    "fName": "The Gilded Senate",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772687197598-Gemini_Generated_Image_mko59pmko59pmko5.jpg?alt=media&token=abb6c0e9-b303-4651-930f-3ffd96b834b0",
    "info": "",
    "lName": "",
    "opt_activeMemberCount": 8,
    "path": "7i9p9j_gwi7x0bwowq",
    "playerId": "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team",
    "points": 0,
    "status": "active",
    "team": true,
    "ts": 1772687714019
  },
  "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT": {
    "alias": "Jealous Narwhal",
    "currency": 0,
    "currencyTotal": 200,
    "displayName": "Theodore C",
    "enroll_method": "upload",
    "fName": "Theodore",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #f10868, #1ab0cb)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Crane",
    "path": "yq78c6apfeqf97sw_-",
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1774623171459
  },
  "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU": {
    "alias": "Confident Giraffe",
    "currency": 1450,
    "currencyTotal": 1450,
    "displayName": "Elara F",
    "enroll_method": "upload",
    "fName": "Elara",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #99064e, #6e8490)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Frost",
    "path": "2uiwtc_w9wo88dhqj9",
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "points": 600,
    "status": "active",
    "team": false,
    "ts": 1774501447697
  },
  "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm": {
    "alias": "Neat Mouse",
    "currency": 300,
    "currencyTotal": 300,
    "displayName": "Leo M",
    "enroll_method": "upload",
    "fName": "Leo",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #d8be5d, #36ef15)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Maxwell",
    "path": "0cq39ufq8-sigmeb3y",
    "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1774615664702
  },
  "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E": {
    "alias": "Reverent Newt",
    "currency": 50,
    "currencyTotal": 250,
    "displayName": "Beatrice K",
    "enroll_method": "upload",
    "fName": "Beatrice",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #04555b, #2c2c09)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Knight",
    "path": "arkjkd_em_5kc_7dsc",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1774663211536
  },
  "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz": {
    "alias": "Mischievous Mouse",
    "currency": 500,
    "currencyTotal": 700,
    "displayName": "Sofia R",
    "enroll_method": "upload",
    "fName": "Sofia",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #8dd86c, #79ba99)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Ricci",
    "path": "bid38pzjhsn52cckdr",
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "points": 150,
    "status": "active",
    "team": false,
    "ts": 1774615665812
  },
  "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm": {
    "alias": "Reflective Mink",
    "currency": 400,
    "currencyTotal": 400,
    "displayName": "Xavier C",
    "enroll_method": "upload",
    "fName": "Xavier",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #03edc1, #684c5e)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Cross",
    "path": "m9pwe3ddnqf0wto0rn",
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "points": 20,
    "status": "active",
    "team": false,
    "ts": 1774615665792
  },
  "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA": {
    "alias": "Honest Moose",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Clara W",
    "enroll_method": "upload",
    "fName": "Clara",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #d9e188, #d8a77f)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Whitlock",
    "path": "0w6gfikhjtsg8k5a6e",
    "playerId": "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr": {
    "alias": "Responsible Grouse",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Gideon H",
    "enroll_method": "upload",
    "fName": "Gideon",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #6bb507, #6d468e)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Holt",
    "path": "f25m7jpgqzguoa8gad",
    "playerId": "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ": {
    "alias": "Joyful Dragonfly",
    "currency": 100,
    "currencyTotal": 100,
    "displayName": "Felix A",
    "enroll_method": "upload",
    "fName": "Felix",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #7473dd, #5c264f)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Aris",
    "path": "nji5j50yzk6a-w66tw",
    "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
    "points": 20,
    "status": "active",
    "team": false,
    "ts": 1774495499894
  },
  "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5": {
    "alias": "Popular Hornet",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Elena V",
    "enroll_method": "upload",
    "fName": "Elena",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #1141b2, #aa3286)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Vance",
    "path": "79yk7k4me-amx5v7oq",
    "playerId": "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team": {
    "currency": 0,
    "currencyTotal": 0,
    "desc": "Inspired by the Legio, the backbone of the Roman army. This name is perfect for a group that is highly organized and tackles challenges with a \"never leave a man behind\" mentality.",
    "displayName": "The Iron Legion",
    "enroll_method": "",
    "fName": "The Iron Legion",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9",
    "info": "",
    "lName": "",
    "opt_activeMemberCount": 9,
    "path": "kihibc_szszkza4zvo",
    "playerId": "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team",
    "points": 0,
    "status": "active",
    "team": true,
    "ts": 1773006992238
  },
  "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0": {
    "alias": "Responsible Eel",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Lydia B",
    "enroll_method": "upload",
    "fName": "Lydia",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #05dbbf, #1d69db)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Bennet",
    "path": "t4zaa6v4qxffjjxqjh",
    "playerId": "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team": {
    "currency": 0,
    "currencyTotal": 0,
    "desc": "Drawing from the Sibylline Oracles and the protectors of sacred knowledge. This name is ideal for the group that digs deep into symbolism and always seems to find the \"hidden meaning\" in the texts you read.",
    "displayName": "The Oracle Guard",
    "enroll_method": "",
    "fName": "The Oracle Guard",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772689891357-oracle-guard.jpg?alt=media&token=81e97221-80a0-4e2c-a355-33c134f2749c",
    "info": "",
    "lName": "",
    "opt_activeMemberCount": 9,
    "path": "w0c77_x8tyf27nm9ee",
    "playerId": "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team",
    "points": 0,
    "status": "active",
    "team": true,
    "ts": 1773002414728
  },
  "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3": {
    "alias": "Pleasing Flamingo",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Maya H",
    "enroll_method": "upload",
    "fName": "Maya",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #f0c657, #d45525)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Huxley",
    "path": "pqmssxtk4ahxkbky96",
    "playerId": "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx": {
    "alias": "Confident Mosquito",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Hazel T",
    "enroll_method": "upload",
    "fName": "Hazel",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #c7c032, #93cd9c)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Thorne",
    "path": "s_zzkdwuk_iqor5b7d",
    "playerId": "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn": {
    "alias": "Questioning Moose",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Quentin M",
    "enroll_method": "upload",
    "fName": "Quentin",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #1d7b17, #a5d001)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Miller",
    "path": "0hwqwaja88v_yhj68f",
    "playerId": "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3": {
    "alias": "Honest Badger",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Adrian C",
    "enroll_method": "upload",
    "fName": "Adrian",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #c6864c, #d3e4c0)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Chen",
    "path": "ewciz9aohx7y0fd8dx",
    "playerId": "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr": {
    "alias": "Bold Mantis",
    "currency": 100,
    "currencyTotal": 100,
    "displayName": "Nadia S",
    "enroll_method": "upload",
    "fName": "Nadia",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #312bcc, #21f35d)",
    "icon": "",
    "info": "HR - Thorne",
    "lName": "Solis",
    "path": "7auhs3ex3h2hcqgnu-",
    "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
    "points": 20,
    "status": "active",
    "team": false,
    "ts": 1774495500431
  },
  "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG": {
    "alias": "Strong Kookabura",
    "currency": 0,
    "currencyTotal": 0,
    "displayName": "Rowan G",
    "enroll_method": "upload",
    "fName": "Rowan",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #e10a7e, #83caed)",
    "icon": "",
    "info": "HR - Blackwood",
    "lName": "Graves",
    "path": "xiss055dto09dgynf7",
    "playerId": "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
    "points": 0,
    "status": "active",
    "team": false,
    "ts": 1772202099979
  }
}

export const leaderList = {
  "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5": {
    "currency": 550,
    "currencyTotal": 950,
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "points": 450
  },
  "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq": {
    "currency": 200,
    "currencyTotal": 200,
    "playerId": "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
    "points": 0
  },
  "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
    "points": 0
  },
  "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9": {
    "currency": 300,
    "currencyTotal": 300,
    "displayName": "Victor H",
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "points": 20
  },
  "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03": {
    "currency": 300,
    "currencyTotal": 300,
    "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
    "points": 0
  },
  "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
    "points": 0
  },
  "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
    "points": 0
  },
  "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur": {
    "currency": 200,
    "currencyTotal": 200,
    "playerId": "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
    "points": 0
  },
  "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team",
    "points": 0
  },
  "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT": {
    "currency": 0,
    "currencyTotal": 200,
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "points": 0
  },
  "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU": {
    "currency": 1450,
    "currencyTotal": 1450,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "points": 600
  },
  "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm": {
    "currency": 300,
    "currencyTotal": 300,
    "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
    "points": 0
  },
  "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E": {
    "currency": 50,
    "currencyTotal": 250,
    "displayName": "Beatrice K",
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "points": 0
  },
  "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz": {
    "currency": 500,
    "currencyTotal": 700,
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "points": 150
  },
  "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm": {
    "currency": 400,
    "currencyTotal": 400,
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "points": 20
  },
  "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
    "points": 0
  },
  "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
    "points": 0
  },
  "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ": {
    "currency": 100,
    "currencyTotal": 100,
    "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
    "points": 20
  },
  "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
    "points": 0
  },
  "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team",
    "points": 0
  },
  "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
    "points": 0
  },
  "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team",
    "points": 0
  },
  "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
    "points": 0
  },
  "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
    "points": 0
  },
  "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
    "points": 0
  },
  "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
    "points": 0
  },
  "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr": {
    "currency": 100,
    "currencyTotal": 100,
    "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
    "points": 20
  },
  "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG": {
    "currency": 0,
    "currencyTotal": 0,
    "playerId": "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
    "points": 0
  }
}

export const previewPasscodes = {
  "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM": "1111",
  "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9": "1111",
  "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn": "1111",
  "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03": "1111",
  "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3": "1111",
  "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F": "1111",
  "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA": "1111",
  "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E": "1111",
  "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz": "1111",
  "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx": "1111",
  "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0": "1111",
  "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm": "1111",
  "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm": "1111",
  "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5": "1111",
  "gameId": "1772165586781-LNymXRI-game",
  "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr": "1111",
  "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ": "1111",
  "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3": "1111",
  "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT": "1111",
  "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG": "1111",
  "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5": "1111",
  "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq": "1111",
  "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur": "1111",
  "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr": "1111",
  "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU": "1111",
  "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf": "1111"
}

export const previewTeamMembers = {
  "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team": {
    "path": "kihibc_szszkza4zvo",
    "members": [
      "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
      "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
      "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
      "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
      "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
      "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
      "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
      "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
      "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm"
    ],
    "teamId": "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team",
    "status": "active"
  },
  "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team": {
    "members": [
      "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
      "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
      "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
      "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
      "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
      "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
      "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
      "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
      "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr"
    ],
    "path": "w0c77_x8tyf27nm9ee",
    "status": "active",
    "teamId": "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team"
  },
  "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team": {
    "members": [
      "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
      "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
      "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
      "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
      "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
      "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
      "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
      "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9"
    ],
    "path": "7i9p9j_gwi7x0bwowq",
    "status": "active",
    "teamId": "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team"
  }
}

export const completePlayerData = {
  "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5": {
    "ts_lastLogin": 1774570819808,
    "fName": "Julian",
    "path": "o0bdk4vme7-ev7p6q3",
    "icon": "",
    "newStuff": [
      {
        "icon": "/images/icons/treasure.png",
        "display": "reward",
        "id": "1774615663448-2Vo46bD7t6SWCo7PN9MPZME5-rewards",
        "ts": 1774615663448,
        "type": "rewards",
        "data": [
          {
            "type": "currency",
            "quantity": 300,
            "id": "currency"
          },
          {
            "quantity": 1,
            "id": "1772590997526-86781-LNymX-prizepack",
            "type": "prizepack"
          }
        ]
      },
      {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "data": [
          {
            "id": "1772230537888-86781-LNymX-item",
            "quantity": 1,
            "type": "items"
          },
          {
            "id": "1772230537891-86781-LNymX-item",
            "quantity": 1,
            "type": "items"
          },
          {
            "type": "items",
            "id": "1772230537888-86781-LNymX-item",
            "quantity": 1
          }
        ],
        "type": "rewards",
        "ts": 1774615663452,
        "id": "1774615663452-2Vo46bD7t6SWCo7PN9MPZME5-prizepack",
        "display": "prizepack"
      }
    ],
    "ts": 1772202099979,
    "lName": "Sterling",
    "challenges": {
      "1772569770551-86781-LNymX-challenge": {
        "id": "1772569770551-86781-LNymX-challenge",
        "approved": true,
        "ts": 1774571686524,
        "tries": 2,
        "count": 1
      },
      "1772569834612-86781-LNymX-challenge": {
        "tries": 2,
        "count": 1,
        "approved": true,
        "id": "1772569834612-86781-LNymX-challenge",
        "ts": 1774571645810
      }
    },
    "displayName": "Julian S",
    "appId": "2Vo46bD7t6SWCo7PN9MPZME5",
    "alias": "Proper Lemur",
    "info": "HR - Thorne",
    "currencyTotal": 950,
    "currency": 550,
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "ts": 1774615663451,
        "count": 1
      }
    },
    "team": false,
    "enroll_method": "upload",
    "legalApproved": 1774570823400,
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
    "points": 450,
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #efbbb5, #5696a5)",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "id": "1772590648474-86781-LNymX-level",
        "ts": 1774570826804,
        "count": 1
      }
    },
    "status": "active",
    "items": {
      "1772230537891-86781-LNymX-item": {
        "id": "1772230537891-86781-LNymX-item",
        "ts": 1774615663454,
        "count": 1
      },
      "1772230537869-86781-LNymX-item": {
        "id": "1772230537869-86781-LNymX-item",
        "ts": 1774572899764,
        "totalSpent": 100,
        "count": 1,
        "total": 1
      },
      "1772230537888-86781-LNymX-item": {
        "ts": 1774615663453,
        "count": 1,
        "id": "1772230537888-86781-LNymX-item"
      },
      "1772230537882-86781-LNymX-item": {
        "ts": 1774572899764,
        "id": "1772230537882-86781-LNymX-item",
        "total": 1,
        "count": 1,
        "totalSpent": 200
      },
      "1772230537874-86781-LNymX-item": {
        "ts": 1774572899764,
        "id": "1772230537874-86781-LNymX-item",
        "count": 1,
        "total": 1,
        "totalSpent": 100
      }
    }
  },
  "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq": {
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Ivy S",
    "gradient": "linear-gradient(to top, #f99e72, #3b2bd3)",
    "alias": "Inventive Mantis",
    "appId": "43jfbVFSXCVW0uMFZk209aXq",
    "status": "active",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "id": "1772590648474-86781-LNymX-level",
        "count": 1,
        "ts": 1773161482263
      }
    },
    "info": "HR - Blackwood",
    "currencyTotal": 200,
    "currency": 200,
    "fName": "Ivy",
    "ts_lastLogin": 1773161480888,
    "icon": "",
    "team": false,
    "newStuff": [],
    "path": "q5cqhyxw6mpw9rd3ni",
    "lName": "Sinclair",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "legalApproved": 1773161491976
  },
  "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf": {
    "appId": "7bPBjTWkxR94cOxfRFHw3UHf",
    "alias": "Faithful Deer",
    "status": "active",
    "info": "HR - Thorne",
    "playerId": "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to top, #065868, #3c6b24)",
    "displayName": "Marcus T",
    "path": "s_04hnqzcm2yjumnb0",
    "icon": "",
    "team": false,
    "enroll_method": "upload",
    "lName": "Thorne",
    "ts": 1772202099979,
    "currencyTotal": 0,
    "currency": 0,
    "fName": "Marcus"
  },
  "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9": {
    "currency": 300,
    "currencyTotal": 300,
    "fName": "Victor",
    "ts_lastLogin": 1774644411726,
    "icon": "",
    "team": false,
    "newStuff": [],
    "path": "x3tvmbhymif00362ni",
    "lName": "Hugo",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "legalApproved": 1774643896068,
    "points": 20,
    "playerId": "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9",
    "ts_joined": 1772202099979,
    "gradient": "linear-gradient(to left, #b8b43c, #9fb4c1)",
    "displayName": "Victor H",
    "gameId": "1772165586781-LNymXRI-game",
    "alias": "Questioning Hawk",
    "appId": "7ms5igiTjjh4cLmunxfSTJU9",
    "info": "HR - Blackwood",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "id": "1772590648474-86781-LNymX-level",
        "count": 1,
        "ts": 1774643897439
      }
    },
    "status": "active"
  },
  "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03": {
    "appId": "A9Z54ybEdO08J7BH5Mpynx03",
    "alias": "Cautious Curlew",
    "status": "active",
    "info": "HR - Thorne",
    "items": {
      "1772230537866-86781-LNymX-item": {
        "id": "1772230537866-86781-LNymX-item",
        "ts": 1774615663454,
        "count": 1
      },
      "1772230537870-86781-LNymX-item": {
        "count": 1,
        "ts": 1774615663456,
        "id": "1772230537870-86781-LNymX-item"
      }
    },
    "playerId": "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to left, #70a495, #cd4f39)",
    "displayName": "Silas V",
    "path": "bmvh6aoda7y9uojcw_",
    "icon": "",
    "team": false,
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "count": 1,
        "ts": 1774615663452,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "newStuff": [
      {
        "data": [
          {
            "quantity": 300,
            "id": "currency",
            "type": "currency"
          },
          {
            "quantity": 1,
            "id": "1772590997526-86781-LNymX-prizepack",
            "type": "prizepack"
          }
        ],
        "ts": 1774615663449,
        "type": "rewards",
        "display": "reward",
        "id": "1774615663449-A9Z54ybEdO08J7BH5Mpynx03-rewards",
        "icon": "/images/icons/treasure.png"
      },
      {
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8",
        "display": "prizepack",
        "id": "1774615663453-A9Z54ybEdO08J7BH5Mpynx03-prizepack",
        "data": [
          {
            "type": "items",
            "id": "1772230537866-86781-LNymX-item",
            "quantity": 1
          },
          {
            "quantity": 1,
            "id": "1772230537866-86781-LNymX-item",
            "type": "items"
          },
          {
            "id": "1772230537870-86781-LNymX-item",
            "quantity": 1,
            "type": "items"
          }
        ],
        "type": "rewards",
        "ts": 1774615663453
      }
    ],
    "enroll_method": "upload",
    "lName": "Vane",
    "ts": 1772202099979,
    "currencyTotal": 300,
    "currency": 300,
    "fName": "Silas"
  },
  "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F": {
    "status": "active",
    "info": "HR - Blackwood",
    "appId": "EDJjcSJkQhCj8Su3009yDf3F",
    "alias": "Busy Jaguar",
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Isabella R",
    "gradient": "linear-gradient(to top, #7d295a, #d61cff)",
    "playerId": "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
    "ts_joined": 1772202099979,
    "points": 0,
    "enroll_method": "upload",
    "lName": "Romero",
    "ts": 1772202099979,
    "path": "0d4po53js6vt59f8zj",
    "icon": "",
    "team": false,
    "fName": "Isabella",
    "currencyTotal": 0,
    "currency": 0
  },
  "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM": {
    "appId": "G8cicVkGq7yorRPXCKd6ydnM",
    "alias": "Popular Dolphin",
    "status": "active",
    "info": "HR - Blackwood",
    "playerId": "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Penelope W",
    "gradient": "linear-gradient(to left, #22e58e, #ff6fa6)",
    "path": "p_ui6ws5754qspj2fk",
    "icon": "",
    "team": false,
    "enroll_method": "upload",
    "lName": "Weaver",
    "ts": 1772202099979,
    "currencyTotal": 0,
    "currency": 0,
    "fName": "Penelope"
  },
  "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur": {
    "alias": "Patient Crane",
    "appId": "GuYrAf2A7ofKh6Kim4OGv2ur",
    "status": "active",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "count": 1,
        "ts": 1772981266523,
        "id": "1772590648474-86781-LNymX-level"
      }
    },
    "info": "HR - Thorne",
    "playerId": "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Jasper F",
    "gradient": "linear-gradient(to top, #12cf02, #ce2e13)",
    "newStuff": [],
    "team": false,
    "icon": "",
    "path": "cudo2o__jhdh0_hm42",
    "lName": "Finch",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "legalApproved": 1772981270753,
    "currencyTotal": 200,
    "currency": 200,
    "fName": "Jasper",
    "ts_lastLogin": 1772980733338
  },
  "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team": {
    "appId": "J9xWK94hGWoQ7Kw05OZo_team",
    "status": "active",
    "ts_joined": 1772686800409,
    "playerId": "1772165586781-LNymXRI-game_J9xWK94hGWoQ7Kw05OZo_team",
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "The Gilded Senate",
    "name": "The Gilded Senate",
    "opt_activeMemberCount": 8,
    "path": "7i9p9j_gwi7x0bwowq",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772687197598-Gemini_Generated_Image_mko59pmko59pmko5.jpg?alt=media&token=abb6c0e9-b303-4651-930f-3ffd96b834b0",
    "team": true,
    "opt_members": [
      "1772165586781-LNymXRI-game_GuYrAf2A7ofKh6Kim4OGv2ur",
      "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
      "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
      "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
      "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
      "1772165586781-LNymXRI-game_7bPBjTWkxR94cOxfRFHw3UHf",
      "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
      "1772165586781-LNymXRI-game_7ms5igiTjjh4cLmunxfSTJU9"
    ],
    "desc": "Named after the Senatus, the governing body of Rome. This title fits a team that excels at the rhetorical and analytical side of your literature curriculum the ones who love a good Socratic seminar.",
    "ts": 1772687199072,
    "fName": "The Gilded Senate"
  },
  "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT": {
    "alias": "Jealous Narwhal",
    "appId": "JSx4p6pOdtEAGMvzmX3AcbwT",
    "items": {
      "1772230537871-86781-LNymX-item": {
        "total": 2,
        "count": 1,
        "totalSpent": 200,
        "ts": 1774623170292,
        "id": "1772230537871-86781-LNymX-item"
      }
    },
    "info": "HR - Blackwood",
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "id": "1772590648474-86781-LNymX-level",
        "count": 1,
        "ts": 1774615595942
      }
    },
    "status": "active",
    "points": 0,
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
    "displayName": "Theodore C",
    "gradient": "linear-gradient(to right, #f10868, #1ab0cb)",
    "gameId": "1772165586781-LNymXRI-game",
    "icon": "",
    "team": false,
    "newStuff": [],
    "path": "yq78c6apfeqf97sw_-",
    "lName": "Crane",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "legalApproved": 1774615592607,
    "currency": 0,
    "currencyTotal": 200,
    "fName": "Theodore",
    "ts_lastLogin": 1774615589881
  },
  "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU": {
    "ts_lastLogin": 1774813401768,
    "fName": "Elara",
    "path": "2uiwtc_w9wo88dhqj9",
    "newStuff": [],
    "icon": "",
    "ts": 1772202099979,
    "lName": "Frost",
    "collections": {
      "1772233183963-86781-LNymX-collection": {
        "id": "1772233183963-86781-LNymX-collection",
        "count": 1,
        "ts": 1774497798492
      }
    },
    "challenges": {
      "1772572118651-86781-LNymX-challenge": {
        "count": 1,
        "ts": 1774501243641,
        "tries": 2,
        "id": "1772572118651-86781-LNymX-challenge"
      },
      "1772569886040-86781-LNymX-challenge": {
        "count": 0,
        "ts": 1774818340234,
        "tries": 1,
        "id": "1772569886040-86781-LNymX-challenge"
      },
      "1772569770551-86781-LNymX-challenge": {
        "ts": 1774498029778,
        "count": 1,
        "id": "1772569770551-86781-LNymX-challenge",
        "tries": 2
      }
    },
    "displayName": "Elara F",
    "appId": "OKBBAo2RM44OS9DjaPrHxwrU",
    "alias": "Confident Giraffe",
    "info": "HR - Blackwood",
    "currencyTotal": 1450,
    "currency": 1450,
    "secretCodes": {
      "1772595348384-86781-LNymX-secretCode": {
        "count": 1,
        "ts": 1774497967887,
        "id": "1772595348384-86781-LNymX-secretCode"
      },
      "1772595348383-86781-LNymX-secretCode": {
        "count": 1,
        "ts": 1774497583571,
        "id": "1772595348383-86781-LNymX-secretCode"
      },
      "1772595348387-86781-LNymX-secretCode": {
        "id": "1772595348387-86781-LNymX-secretCode",
        "ts": 1774497798483,
        "count": 1
      }
    },
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "ts": 1774501446840,
        "count": 4,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "team": false,
    "legalApproved": 1774497543178,
    "enroll_method": "upload",
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
    "points": 600,
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #99064e, #6e8490)",
    "status": "active",
    "levels": {
      "1772590711756-86781-LNymX-level": {
        "id": "1772590711756-86781-LNymX-level",
        "ts": 1774501446837,
        "count": 1
      },
      "1772590648474-86781-LNymX-level": {
        "count": 1,
        "ts": 1774497543501,
        "id": "1772590648474-86781-LNymX-level"
      }
    },
    "items": {
      "1772230537888-86781-LNymX-item": {
        "ts": 1774497583577,
        "count": 1,
        "id": "1772230537888-86781-LNymX-item"
      },
      "1772230537868-86781-LNymX-item": {
        "ts": 1774497798487,
        "count": 1,
        "id": "1772230537868-86781-LNymX-item"
      },
      "1772230537887-86781-LNymX-item": {
        "ts": 1774497798492,
        "count": 1,
        "total": 1,
        "id": "1772230537887-86781-LNymX-item"
      },
      "1772230537870-86781-LNymX-item": {
        "count": 1,
        "ts": 1774497967891,
        "id": "1772230537870-86781-LNymX-item"
      },
      "1772230537891-86781-LNymX-item": {
        "id": "1772230537891-86781-LNymX-item",
        "count": 1,
        "ts": 1774497798488
      },
      "1772230537889-86781-LNymX-item": {
        "id": "1772230537889-86781-LNymX-item",
        "ts": 1774497798489,
        "count": 1
      },
      "1772230537890-86781-LNymX-item": {
        "ts": 1774497583575,
        "count": 1,
        "id": "1772230537890-86781-LNymX-item"
      },
      "1772230537866-86781-LNymX-item": {
        "ts": 1774497583576,
        "count": 1,
        "id": "1772230537866-86781-LNymX-item"
      }
    }
  },
  "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm": {
    "currency": 300,
    "currencyTotal": 300,
    "fName": "Leo",
    "icon": "",
    "team": false,
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "count": 1,
        "ts": 1774615663449
      }
    },
    "newStuff": [
      {
        "icon": "/images/icons/treasure.png",
        "id": "1774615663446-YF29Cw25nRFWUe6t37OtFiwm-rewards",
        "display": "reward",
        "data": [
          {
            "quantity": 300,
            "id": "currency",
            "type": "currency"
          },
          {
            "type": "prizepack",
            "quantity": 1,
            "id": "1772590997526-86781-LNymX-prizepack"
          }
        ],
        "type": "rewards",
        "ts": 1774615663446
      },
      {
        "display": "prizepack",
        "id": "1774615663450-YF29Cw25nRFWUe6t37OtFiwm-prizepack",
        "ts": 1774615663450,
        "type": "rewards",
        "data": [
          {
            "quantity": 1,
            "id": "1772230537890-86781-LNymX-item",
            "type": "items"
          },
          {
            "quantity": 1,
            "id": "1772230537889-86781-LNymX-item",
            "type": "items"
          },
          {
            "id": "1772230537875-86781-LNymX-item",
            "quantity": 1,
            "type": "items"
          }
        ],
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8"
      }
    ],
    "path": "0cq39ufq8-sigmeb3y",
    "ts": 1772202099979,
    "lName": "Maxwell",
    "enroll_method": "upload",
    "points": 0,
    "playerId": "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
    "ts_joined": 1772202099979,
    "displayName": "Leo M",
    "gradient": "linear-gradient(to left, #d8be5d, #36ef15)",
    "gameId": "1772165586781-LNymXRI-game",
    "alias": "Neat Mouse",
    "appId": "YF29Cw25nRFWUe6t37OtFiwm",
    "items": {
      "1772230537889-86781-LNymX-item": {
        "id": "1772230537889-86781-LNymX-item",
        "count": 1,
        "ts": 1774615663452
      },
      "1772230537890-86781-LNymX-item": {
        "ts": 1774615663451,
        "count": 1,
        "id": "1772230537890-86781-LNymX-item"
      },
      "1772230537875-86781-LNymX-item": {
        "ts": 1774615663453,
        "count": 1,
        "id": "1772230537875-86781-LNymX-item"
      }
    },
    "info": "HR - Thorne",
    "status": "active"
  },
  "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E": {
    "currency": 50,
    "currencyTotal": 250,
    "secretCodes": {
      "1772595348386-86781-LNymX-secretCode": {
        "count": 1,
        "ts": 1774663210139,
        "id": "1772595348386-86781-LNymX-secretCode"
      }
    },
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "ts": 1774663210141,
        "count": 1
      }
    },
    "team": false,
    "enroll_method": "upload",
    "legalApproved": 1774663159555,
    "points": 0,
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
    "gradient": "linear-gradient(to bottom, #04555b, #2c2c09)",
    "gameId": "1772165586781-LNymXRI-game",
    "items": {
      "1772230537866-86781-LNymX-item": {
        "id": "1772230537866-86781-LNymX-item",
        "count": 1,
        "ts": 1774663210144
      },
      "1772230537875-86781-LNymX-item": {
        "id": "1772230537875-86781-LNymX-item",
        "ts": 1774663210145,
        "count": 1
      },
      "1772230537868-86781-LNymX-item": {
        "id": "1772230537868-86781-LNymX-item",
        "count": 1,
        "ts": 1774663210143
      },
      "1772230537885-86781-LNymX-item": {
        "total": 1,
        "count": 1,
        "totalSpent": 200,
        "id": "1772230537885-86781-LNymX-item",
        "ts": 1774663185406
      }
    },
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "ts": 1774663161105,
        "count": 1,
        "id": "1772590648474-86781-LNymX-level"
      }
    },
    "status": "active",
    "ts_lastLogin": 1774663155925,
    "fName": "Beatrice",
    "path": "arkjkd_em_5kc_7dsc",
    "icon": "",
    "newStuff": [],
    "ts": 1772202099979,
    "lName": "Knight",
    "displayName": "Beatrice K",
    "appId": "ZCYz3Xwi3rCgnv6BMyZPV88E",
    "alias": "Reverent Newt",
    "info": "HR - Thorne"
  },
  "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz": {
    "gradient": "linear-gradient(to bottom, #8dd86c, #79ba99)",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 150,
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_ZvZ0CMN6ywykvdvTHuOPvRKz",
    "items": {
      "1772230537890-86781-LNymX-item": {
        "id": "1772230537890-86781-LNymX-item",
        "ts": 1774535601051,
        "count": 1
      },
      "1772230537866-86781-LNymX-item": {
        "count": 1,
        "ts": 1774535601052,
        "id": "1772230537866-86781-LNymX-item"
      },
      "1772230537875-86781-LNymX-item": {
        "count": 1,
        "ts": 1774615663452,
        "id": "1772230537875-86781-LNymX-item"
      },
      "1772230537881-86781-LNymX-item": {
        "total": 1,
        "count": 1,
        "totalSpent": 200,
        "id": "1772230537881-86781-LNymX-item",
        "ts": 1774535391305
      },
      "1772230537868-86781-LNymX-item": {
        "ts": 1774615663453,
        "count": 1,
        "id": "1772230537868-86781-LNymX-item"
      },
      "1772230537888-86781-LNymX-item": {
        "id": "1772230537888-86781-LNymX-item",
        "count": 1,
        "ts": 1774535601053
      }
    },
    "levels": {
      "1772590648474-86781-LNymX-level": {
        "ts": 1774535368931,
        "count": 1,
        "id": "1772590648474-86781-LNymX-level"
      }
    },
    "status": "active",
    "currency": 500,
    "currencyTotal": 700,
    "enroll_method": "upload",
    "legalApproved": 1774535371260,
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "id": "1772590997526-86781-LNymX-prizepack",
        "ts": 1774615663450,
        "count": 2
      }
    },
    "team": false,
    "secretCodes": {
      "1772595348385-86781-LNymX-secretCode": {
        "id": "1772595348385-86781-LNymX-secretCode",
        "ts": 1774535601047,
        "count": 1
      }
    },
    "displayName": "Sofia R",
    "challenges": {
      "1772569770551-86781-LNymX-challenge": {
        "count": 0,
        "tries": 1,
        "ts": 1774536340963,
        "id": "1772569770551-86781-LNymX-challenge",
        "declined": 1
      },
      "1772569886040-86781-LNymX-challenge": {
        "count": 1,
        "ts": 1774535538361,
        "tries": 2,
        "id": "1772569886040-86781-LNymX-challenge"
      }
    },
    "info": "HR - Thorne",
    "alias": "Mischievous Mouse",
    "appId": "ZvZ0CMN6ywykvdvTHuOPvRKz",
    "fName": "Sofia",
    "ts_lastLogin": 1774535366694,
    "ts": 1772202099979,
    "lName": "Ricci",
    "icon": "",
    "newStuff": [
      {
        "display": "achievement",
        "id": "1774572338000-ZvZ0CMN6ywykvdvTHuOPvRKz-approvedChallenge",
        "data": [
          {
            "id": "xp",
            "quantity": 150,
            "type": "xp"
          },
          {
            "id": "currency",
            "quantity": 150,
            "type": "currency"
          }
        ],
        "elementId": "1772569886040-86781-LNymX-challenge",
        "type": "approvedChallenge",
        "ts": 1774572338000,
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569884817-veni.png?alt=media&token=dbf3d911-e380-45f3-9e2d-b9d3e74c3945"
      },
      {
        "display": "playerActivity",
        "id": "1774572403947-ZvZ0CMN6ywykvdvTHuOPvRKz-declinedChallenge",
        "ts": 1774572403947,
        "type": "declinedChallenge",
        "elementId": "1772569770551-86781-LNymX-challenge",
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772569769262-forum.png?alt=media&token=09226661-f2a7-4d71-aa90-c96c09c9c6bb"
      },
      {
        "icon": "/images/icons/treasure.png",
        "data": [
          {
            "quantity": 300,
            "id": "currency",
            "type": "currency"
          },
          {
            "type": "prizepack",
            "quantity": 1,
            "id": "1772590997526-86781-LNymX-prizepack"
          }
        ],
        "ts": 1774615663447,
        "type": "rewards",
        "id": "1774615663447-ZvZ0CMN6ywykvdvTHuOPvRKz-rewards",
        "display": "reward"
      },
      {
        "display": "prizepack",
        "id": "1774615663451-ZvZ0CMN6ywykvdvTHuOPvRKz-prizepack",
        "ts": 1774615663451,
        "type": "rewards",
        "data": [
          {
            "type": "items",
            "id": "1772230537875-86781-LNymX-item",
            "quantity": 1
          },
          {
            "type": "items",
            "quantity": 1,
            "id": "1772230537868-86781-LNymX-item"
          },
          {
            "type": "items",
            "quantity": 1,
            "id": "1772230537868-86781-LNymX-item"
          }
        ],
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8"
      }
    ],
    "path": "bid38pzjhsn52cckdr"
  },
  "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm": {
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Xavier C",
    "gradient": "linear-gradient(to right, #03edc1, #684c5e)",
    "playerId": "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
    "ts_joined": 1772202099979,
    "points": 20,
    "status": "active",
    "info": "HR - Blackwood",
    "items": {
      "1772230537868-86781-LNymX-item": {
        "id": "1772230537868-86781-LNymX-item",
        "count": 1,
        "ts": 1774615663452
      },
      "1772230537866-86781-LNymX-item": {
        "id": "1772230537866-86781-LNymX-item",
        "ts": 1774615663450,
        "count": 1
      }
    },
    "appId": "axOQve3xXxzhqJ7OPczuoZFm",
    "alias": "Reflective Mink",
    "ts_lastLogin": 1772894684244,
    "fName": "Xavier",
    "currencyTotal": 400,
    "currency": 400,
    "legalApproved": 1772894691873,
    "enroll_method": "upload",
    "lName": "Cross",
    "ts": 1772202099979,
    "path": "m9pwe3ddnqf0wto0rn",
    "team": false,
    "newStuff": [
      {
        "icon": "/images/icons/treasure.png",
        "id": "1774495493476-axOQve3xXxzhqJ7OPczuoZFm-rewards",
        "display": "reward",
        "data": [
          {
            "id": "xp",
            "quantity": 20,
            "type": "xp"
          },
          {
            "type": "currency",
            "quantity": 100,
            "id": "currency"
          }
        ],
        "ts": 1774495493476,
        "type": "rewards"
      },
      {
        "icon": "/images/icons/treasure.png",
        "id": "1774615663445-axOQve3xXxzhqJ7OPczuoZFm-rewards",
        "display": "reward",
        "ts": 1774615663445,
        "type": "rewards",
        "data": [
          {
            "type": "currency",
            "id": "currency",
            "quantity": 300
          },
          {
            "type": "prizepack",
            "quantity": 1,
            "id": "1772590997526-86781-LNymX-prizepack"
          }
        ]
      },
      {
        "display": "prizepack",
        "id": "1774615663449-axOQve3xXxzhqJ7OPczuoZFm-prizepack",
        "ts": 1774615663449,
        "type": "rewards",
        "data": [
          {
            "id": "1772230537866-86781-LNymX-item",
            "quantity": 1,
            "type": "items"
          },
          {
            "quantity": 1,
            "id": "1772230537866-86781-LNymX-item",
            "type": "items"
          },
          {
            "type": "items",
            "quantity": 1,
            "id": "1772230537868-86781-LNymX-item"
          }
        ],
        "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772590995761-chest.png?alt=media&token=ac060be6-7b79-42f7-ad90-456fa5998df8"
      }
    ],
    "prizepacks": {
      "1772590997526-86781-LNymX-prizepack": {
        "ts": 1774615663448,
        "count": 1,
        "id": "1772590997526-86781-LNymX-prizepack"
      }
    },
    "icon": ""
  },
  "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA": {
    "info": "HR - Thorne",
    "status": "active",
    "appId": "cVwFFJ72qLb6vLiLeFMwnEcA",
    "alias": "Honest Moose",
    "displayName": "Clara W",
    "gradient": "linear-gradient(to right, #d9e188, #d8a77f)",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "playerId": "1772165586781-LNymXRI-game_cVwFFJ72qLb6vLiLeFMwnEcA",
    "ts_joined": 1772202099979,
    "enroll_method": "upload",
    "lName": "Whitlock",
    "ts": 1772202099979,
    "path": "0w6gfikhjtsg8k5a6e",
    "team": false,
    "icon": "",
    "fName": "Clara",
    "currency": 0,
    "currencyTotal": 0
  },
  "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr": {
    "gradient": "linear-gradient(to top, #6bb507, #6d468e)",
    "displayName": "Gideon H",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "playerId": "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
    "ts_joined": 1772202099979,
    "info": "HR - Blackwood",
    "status": "active",
    "alias": "Responsible Grouse",
    "appId": "cx9brBsPCSThk2ZdNLRSnukr",
    "fName": "Gideon",
    "currency": 0,
    "currencyTotal": 0,
    "lName": "Holt",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "icon": "",
    "team": false,
    "path": "f25m7jpgqzguoa8gad"
  },
  "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ": {
    "appId": "dorHnQBtZQdnQ2brude9SEdJ",
    "alias": "Joyful Dragonfly",
    "status": "active",
    "info": "HR - Thorne",
    "playerId": "1772165586781-LNymXRI-game_dorHnQBtZQdnQ2brude9SEdJ",
    "ts_joined": 1772202099979,
    "points": 20,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Felix A",
    "gradient": "linear-gradient(to left, #7473dd, #5c264f)",
    "path": "nji5j50yzk6a-w66tw",
    "icon": "",
    "team": false,
    "newStuff": [
      {
        "icon": "/images/icons/treasure.png",
        "id": "1774495493475-dorHnQBtZQdnQ2brude9SEdJ-rewards",
        "display": "reward",
        "type": "rewards",
        "ts": 1774495493475,
        "data": [
          {
            "type": "xp",
            "id": "xp",
            "quantity": 20
          },
          {
            "type": "currency",
            "quantity": 100,
            "id": "currency"
          }
        ]
      }
    ],
    "enroll_method": "upload",
    "lName": "Aris",
    "ts": 1772202099979,
    "currencyTotal": 100,
    "currency": 100,
    "fName": "Felix"
  },
  "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5": {
    "enroll_method": "upload",
    "lName": "Vance",
    "ts": 1772202099979,
    "path": "79yk7k4me-amx5v7oq",
    "icon": "",
    "team": false,
    "fName": "Elena",
    "currencyTotal": 0,
    "currency": 0,
    "status": "active",
    "info": "HR - Thorne",
    "appId": "eNuL3JKENON6662mFntnZyv5",
    "alias": "Popular Hornet",
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Elena V",
    "gradient": "linear-gradient(to top, #1141b2, #aa3286)",
    "ts_joined": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
    "points": 0
  },
  "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team": {
    "name": "The Iron Legion",
    "opt_activeMemberCount": 9,
    "path": "kihibc_szszkza4zvo",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772686631131-Gemini_Generated_Image_ffy6n0ffy6n0ffy6.jpg?alt=media&token=a1682f9a-cc82-4688-827b-84a59fa592d9",
    "team": true,
    "opt_members": [
      "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
      "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
      "1772165586781-LNymXRI-game_G8cicVkGq7yorRPXCKd6ydnM",
      "1772165586781-LNymXRI-game_A9Z54ybEdO08J7BH5Mpynx03",
      "1772165586781-LNymXRI-game_ZCYz3Xwi3rCgnv6BMyZPV88E",
      "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
      "1772165586781-LNymXRI-game_OKBBAo2RM44OS9DjaPrHxwrU",
      "1772165586781-LNymXRI-game_cx9brBsPCSThk2ZdNLRSnukr",
      "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm"
    ],
    "desc": "Inspired by the Legio, the backbone of the Roman army. This name is perfect for a group that is highly organized and tackles challenges with a \"never leave a man behind\" mentality.",
    "ts": 1773006986422,
    "fName": "The Iron Legion",
    "appId": "eRzU3eBELXk4t0Zaf5Bb_team",
    "status": "active",
    "ts_joined": 1772686313525,
    "playerId": "1772165586781-LNymXRI-game_eRzU3eBELXk4t0Zaf5Bb_team",
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "The Iron Legion"
  },
  "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0": {
    "appId": "emdu4nKOrWqe9ATaTLi5Axc0",
    "alias": "Responsible Eel",
    "status": "active",
    "info": "HR - Blackwood",
    "playerId": "1772165586781-LNymXRI-game_emdu4nKOrWqe9ATaTLi5Axc0",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Lydia B",
    "gradient": "linear-gradient(to right, #05dbbf, #1d69db)",
    "path": "t4zaa6v4qxffjjxqjh",
    "icon": "",
    "team": false,
    "enroll_method": "upload",
    "lName": "Bennet",
    "ts": 1772202099979,
    "currencyTotal": 0,
    "currency": 0,
    "fName": "Lydia"
  },
  "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team": {
    "appId": "h8k7HFwBmE4vrFzfMS9G_team",
    "status": "active",
    "playerId": "1772165586781-LNymXRI-game_h8k7HFwBmE4vrFzfMS9G_team",
    "ts_joined": 1772687769760,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "The Oracle Guard",
    "opt_activeMemberCount": 9,
    "name": "The Oracle Guard",
    "icon": "https://firebasestorage.googleapis.com/v0/b/gamably-app.appspot.com/o/LNymXRIM2ASSsSrLza6lfvWLXKz2%2F1772689891357-oracle-guard.jpg?alt=media&token=81e97221-80a0-4e2c-a355-33c134f2749c",
    "team": true,
    "path": "w0c77_x8tyf27nm9ee",
    "opt_members": [
      "1772165586781-LNymXRI-game_EDJjcSJkQhCj8Su3009yDf3F",
      "1772165586781-LNymXRI-game_YF29Cw25nRFWUe6t37OtFiwm",
      "1772165586781-LNymXRI-game_2Vo46bD7t6SWCo7PN9MPZME5",
      "1772165586781-LNymXRI-game_eNuL3JKENON6662mFntnZyv5",
      "1772165586781-LNymXRI-game_43jfbVFSXCVW0uMFZk209aXq",
      "1772165586781-LNymXRI-game_JSx4p6pOdtEAGMvzmX3AcbwT",
      "1772165586781-LNymXRI-game_axOQve3xXxzhqJ7OPczuoZFm",
      "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
      "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr"
    ],
    "ts": 1773002413898,
    "desc": "Drawing from the Sibylline Oracles and the protectors of sacred knowledge. This name is ideal for the group that digs deep into symbolism and always seems to find the \"hidden meaning\" in the texts you read.",
    "fName": "The Oracle Guard"
  },
  "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3": {
    "fName": "Maya",
    "currency": 0,
    "currencyTotal": 0,
    "enroll_method": "upload",
    "lName": "Huxley",
    "ts": 1772202099979,
    "path": "pqmssxtk4ahxkbky96",
    "icon": "",
    "team": false,
    "gradient": "linear-gradient(to left, #f0c657, #d45525)",
    "displayName": "Maya H",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "playerId": "1772165586781-LNymXRI-game_iwdiTziEseTdazwH7CNQ4cQ3",
    "ts_joined": 1772202099979,
    "info": "HR - Thorne",
    "status": "active",
    "appId": "iwdiTziEseTdazwH7CNQ4cQ3",
    "alias": "Pleasing Flamingo"
  },
  "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx": {
    "playerId": "1772165586781-LNymXRI-game_oVnAPXEE9kyQjHUCnMyZ22Bx",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #c7c032, #93cd9c)",
    "displayName": "Hazel T",
    "appId": "oVnAPXEE9kyQjHUCnMyZ22Bx",
    "alias": "Confident Mosquito",
    "status": "active",
    "info": "HR - Blackwood",
    "currencyTotal": 0,
    "currency": 0,
    "fName": "Hazel",
    "path": "s_zzkdwuk_iqor5b7d",
    "icon": "",
    "team": false,
    "enroll_method": "upload",
    "lName": "Thorne",
    "ts": 1772202099979
  },
  "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn": {
    "ts_lastLogin": 1773108928574,
    "fName": "Quentin",
    "currency": 0,
    "currencyTotal": 0,
    "enroll_method": "upload",
    "ts": 1772202099979,
    "lName": "Miller",
    "path": "0hwqwaja88v_yhj68f",
    "icon": "",
    "team": false,
    "displayName": "Quentin M",
    "gradient": "linear-gradient(to top, #1d7b17, #a5d001)",
    "gameId": "1772165586781-LNymXRI-game",
    "points": 0,
    "playerId": "1772165586781-LNymXRI-game_opW78wiKB0bZREJcvuaYOKYn",
    "ts_joined": 1772202099979,
    "info": "HR - Blackwood",
    "status": "active",
    "appId": "opW78wiKB0bZREJcvuaYOKYn",
    "alias": "Questioning Moose"
  },
  "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3": {
    "fName": "Adrian",
    "currencyTotal": 0,
    "currency": 0,
    "lName": "Chen",
    "ts": 1772202099979,
    "enroll_method": "upload",
    "team": false,
    "icon": "",
    "path": "ewciz9aohx7y0fd8dx",
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to right, #c6864c, #d3e4c0)",
    "displayName": "Adrian C",
    "playerId": "1772165586781-LNymXRI-game_vjAwf0SQG9VKrhzeyiN2bSS3",
    "ts_joined": 1772202099979,
    "points": 0,
    "status": "active",
    "info": "HR - Thorne",
    "alias": "Honest Badger",
    "appId": "vjAwf0SQG9VKrhzeyiN2bSS3"
  },
  "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr": {
    "currencyTotal": 100,
    "currency": 100,
    "fName": "Nadia",
    "path": "7auhs3ex3h2hcqgnu-",
    "icon": "",
    "team": false,
    "newStuff": [
      {
        "data": [
          {
            "type": "xp",
            "id": "xp",
            "quantity": 20
          },
          {
            "type": "currency",
            "id": "currency",
            "quantity": 100
          }
        ],
        "type": "rewards",
        "ts": 1774495493478,
        "id": "1774495493478-w77EzNVefc5J22ZSzabDvbQr-rewards",
        "display": "reward",
        "icon": "/images/icons/treasure.png"
      }
    ],
    "enroll_method": "upload",
    "lName": "Solis",
    "ts": 1772202099979,
    "playerId": "1772165586781-LNymXRI-game_w77EzNVefc5J22ZSzabDvbQr",
    "ts_joined": 1772202099979,
    "points": 20,
    "gameId": "1772165586781-LNymXRI-game",
    "gradient": "linear-gradient(to bottom, #312bcc, #21f35d)",
    "displayName": "Nadia S",
    "appId": "w77EzNVefc5J22ZSzabDvbQr",
    "alias": "Bold Mantis",
    "status": "active",
    "info": "HR - Thorne"
  },
  "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG": {
    "alias": "Strong Kookabura",
    "appId": "zqXbjKmmoiZaZEsNV9tgxQrG",
    "status": "active",
    "info": "HR - Blackwood",
    "playerId": "1772165586781-LNymXRI-game_zqXbjKmmoiZaZEsNV9tgxQrG",
    "ts_joined": 1772202099979,
    "points": 0,
    "gameId": "1772165586781-LNymXRI-game",
    "displayName": "Rowan G",
    "gradient": "linear-gradient(to right, #e10a7e, #83caed)",
    "icon": "",
    "team": false,
    "path": "xiss055dto09dgynf7",
    "ts": 1772202099979,
    "lName": "Graves",
    "enroll_method": "upload",
    "currencyTotal": 0,
    "currency": 0,
    "fName": "Rowan"
  }
}